import { ComponentProps } from 'react';
import { ControlledSingleSelectFieldEditorPopover } from './controlled-single-select-field-editor-popover';
import { withFocusableSelect } from '../components/with-focusable-select';

export const SingleSelectFieldEditorPopover = withFocusableSelect<
  number | null,
  ComponentProps<typeof ControlledSingleSelectFieldEditorPopover>
>(ControlledSingleSelectFieldEditorPopover);
